import type { APIResponse } from "@/types/drivers/api"

export function isDisplayedDriverReview(
  review: APIResponse["data"]["reviews"][number],
): boolean {
  return review.rating >= 4
}
